

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";

import {LockerCellActions} from "@/constants/locker";
import {IModule} from "@/model/Locker/IModule";
import {ICell, IRestrictions} from "@/model/Locker/lockerInterfaces";
import LMScreen from "@/components/locker/modules/LMScreen.vue";
import {IOnOffHandlers} from "bonomo/dist";
import {namespace} from "vuex-class";
import { EOrderTypes, IListOrder, ISpikeError } from "@/model/Order/orderInterfaces";
import LMRestrictCellDialog from '@/components/locker/modules/LMRestrictCellDialog.vue'
import LMOpenCellDialog from '@/components/locker/modules/LMOpenCellDialog.vue'
import ServiceProviderChip from "@/components/shared/chips/ServiceProviderChip.vue";
import {IShortServiceProvider} from "@/model/shortInterfaces";
import OrderInCellTooltip from "@/components/locker/modules/OrderInCellTooltip.vue";
import RestrictSPInCellTooltip from "@/components/locker/modules/RestrictSPInCellTooltip.vue";
import OrderChip from "@/components/shared/chips/OrderChip.vue";
import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";

const lockerModule = namespace("lockerModule");
const serviceProviderModule = namespace("serviceProviderModule");

  @Component({
    name: 'LMModule',
    components: {
      LMRestrictCellDialog,
      LMOpenCellDialog,
      LMScreen,
      ServiceProviderChip,
      OrderInCellTooltip,
      RestrictSPInCellTooltip,
      SimpleConfirmationDialog,
    },
  })
  export default class LMModule extends Vue {

    @Prop()
    protected module!: IModule;
    @Prop()
    protected lockerId!: number;
    @Prop()
    protected canInstallLocker!: boolean;
    @Prop({default: false})
    protected isHidden!: boolean;
    @Prop()
    protected action!: number;
    @Prop({default: () => []})
    protected lockersOrders!: IListOrder[];
    @Prop()
    protected lockerProviders!: IShortServiceProvider[];

    @serviceProviderModule.Getter('serviceProvidersByIds')
    protected serviceProvidersByIds!: (ids: number[]) => IShortServiceProvider[]

    protected actionList = LockerCellActions;
    protected currentCellId: number = 0;
    protected currentRestrictedProviders: IShortServiceProvider[] = [];
    protected showDialog: boolean = false;
    protected showOpenCellDialog: boolean = false;
    protected openCellTarget: ICell | null = null;
    protected cellOpened: boolean = false;
    protected orderCollected: boolean = false;
    protected showOrderMenu: boolean = false;
    protected orderInput: number = 0;
    protected submitting: boolean = false;
    private ons: IOnOffHandlers = {};

    public created() {
      this.ons = this.$ons({
        'backend.call.begin.lockerUpdated': this.onSubmitting,
        'backend.call.OK.lockerUpdated': this.onOK,
        'backend.call.KO.lockerUpdated': this.onSubmittingEnd,
        'backend.call.begin.cellOpened': this.onSubmitting,
        'backend.call.OK.cellOpened': this.onCellOpenedOK,
        'backend.call.KO.cellOpened': this.onSubmittingEnd,
        'backend.call.begin.orderCollected': this.onSubmitting,
        'backend.call.OK.orderCollected': this.onOrderCollectedOK,
        'backend.call.KO.orderCollected': this.onSubmittingEnd,
        'backend.call.begin.takeScreenShot': this.onSubmitting,
        'backend.call.OK.takeScreenShot': this.onOK,
        'backend.call.KO.takeScreenShot': this.onSubmittingEnd,
      });
    }

    public beforeDestroy() {
      this.$offs(this.ons);
    }

    protected restrictedSP(restrictions: IRestrictions[]): IShortServiceProvider[] {
      const ids: number[] = restrictions.map((res: IRestrictions) => res.service_provider_id);
      return this.serviceProvidersByIds(ids);
    }

    protected showOrderInCell(cell: ICell) {
      const hasOrder = !!this.orderInCell(cell.id);
      if (!cell.active && hasOrder) {
        return true;
      }
      return hasOrder && [this.actionList.disable, this.actionList.unlock].includes(this.action);
    }

    protected showCellRestrictions(cell: ICell) {
      return cell.restrictions && cell.restrictions.length > 0 && this.actionList.restrict === this.action
    }

    protected moduleClass(module: IModule) {
      let ret: any = {
        "lm-module": true,
      };
      ret['lm-module--'+module.type] = true;
      return ret;
    }
    protected cellClass(cell: ICell) {
      return [
        'lm-cell',
        'lm-cell--' + cell.cell_size_id,
        cell.active ? '' : 'lm-cell--disabled',
        this.orderInCell(cell.id) ? 'lm-cell--inuse' : '',
        this.actionList.restrict === this.action ? 'lm-cell-restrictions': '',
        this.dwellTimeClass(cell.id),
      ];
    }
    protected cellTitle(cell: ICell) {
      if (!cell.active) {
        return 'lockers.install.cells.features.disabled';
      }
    }
    protected orderInCell(cellId: number): IListOrder|undefined {
      const order: IListOrder|undefined = this.lockersOrders.find((each) => each.locker_cell_id == cellId);
      return order ? order : undefined;
    }

    protected spikeError(cell: ICell): ISpikeError|undefined {
      const order = this.orderInCell(cell.id);
      return order && order.spike_error ? order.spike_error : undefined;
    }

    protected spikeErrorTitle(cell: ICell): string {
      const err = this.spikeError(cell);
      if (!err) return '';
      return this.$t('orders.order.logs.actions.700') + ': ' + err.operation + ' - ' + err.message;
    }

    protected orderTypeIcon(cellId: number): string {
      const order = this.orderInCell(cellId);
      const ret = OrderChip.chipStyleOf(order ? order.type : '');
      return ret.icon;
    }
    protected orderServiceProvider(cellId: number): any {
      const order = this.orderInCell(cellId);
      return (order && order.service_provider)
        ? order.service_provider.name
        : (order && (order.type == EOrderTypes.delivery_with_code) ? this.$t('orders.order.types.delivery_with_code') : '');
    }
    protected onBlockBtn(module: IModule) {
      this.$emit('block-button-clicked', module);
    }
    protected onCelldisableBtn(cell: ICell) {
      this.$store.dispatch('lockerModule/disableCell', {
        lockerId: this.lockerId,
        cellId: cell.id,
        disabled: cell.active
      });
    }
    protected onToggleAccessiblityBtn(cell: ICell) {
      this.$store.dispatch('lockerModule/cellAccessible', {
        lockerId: this.lockerId,
        cellId: cell.id,
        accessible: !cell.accessible
      });
    }

    protected onOpenCellBtn(cell: ICell) {
      this.openCellTarget = cell;
      const order = this.orderInCell(cell.id);
      if (order && order.type === EOrderTypes.delivery_with_code) {
        this.showOpenCellDialog = true;
      } else {
        this.$store.dispatch('lockerModule/openCell', {
          lockerId: this.lockerId,
          cellId: cell.id,
        });
      }
    }

    protected onOpenCell() {
      if (!this.openCellTarget) return;
      this.$store.dispatch('lockerModule/openCell', {
        lockerId: this.lockerId,
        cellId: this.openCellTarget.id,
      });
    }

    protected get openCellOrder(): IListOrder | null {
      if (!this.openCellTarget) return null;
      return this.orderInCell(this.openCellTarget.id) || null;
    }

    protected onOpenForCollect() {
      if (!this.openCellOrder) return;
      this.$store.dispatch('lockerModule/finalizeCellOrder', {
        orderId: this.openCellOrder.id,
      });
    }

    protected dwellTimeHours(cellId: number): number | null {
      const order = this.orderInCell(cellId);
      if (!order || !order.created_at) {
        return null;
      }
      const ts = new Date(order.created_at).getTime();
      if (Number.isNaN(ts)) {
        return null;
      }
      return (Date.now() - ts) / (1000 * 60 * 60);
    }

    protected dwellTimeClass(cellId: number): string {
      const hours = this.dwellTimeHours(cellId);
      if (hours === null || hours < 24) {
        return '';
      }
      return hours >= 72 ? 'lm-cell--dwell-72h' : 'lm-cell--dwell-24h';
    }

    protected onRestrictCellBtn(cell: ICell) {
       this.currentRestrictedProviders = this.restrictedSP(cell.restrictions);
       this.currentCellId = cell.id;
       this.showDialog = true;
    }

    protected onSaveOrder() {
      this.$emit('set-order', { module: this.module, order: this.orderInput || 0 });
      this.showOrderMenu = false;
    }

    protected onCloseRestrictCellBtn() {
      this.showDialog = false;
    }

    private onSubmitting() {
      this.submitting = true;
    }
    private onSubmittingEnd() {
      this.submitting = false;
      this.cellOpened = false;
    }
    private onOK() {
      this.submitting = false;
    }
    private onCellOpenedOK() {
      this.submitting = false;
      this.cellOpened = true;
    }
    private onOrderCollectedOK() {
      this.submitting = false;
      this.orderCollected = true;
    }
    private goToOrderPage(cellId: number): object | undefined {
      const order: IListOrder|undefined = this.lockersOrders.find((each) => each.locker_cell_id == cellId);
      return order ? { name: 'order', params: {orderId: order.id}} : undefined;
    }
  }

